import { CpsReportIssueState } from '@cs-cms/types';
import { Button } from '@progress/kendo-react-buttons';
import React from 'react';

interface ReportIssueBodyProps {
  reportIssueState: CpsReportIssueState;
  className?: string;
}

const ReportIssueBody: React.FC<ReportIssueBodyProps> = ({ reportIssueState, className }) => {
  return (
    <div className={className || ''}>
      <div
        dangerouslySetInnerHTML={{
          __html: reportIssueState.keyUsersContactsContent || ''
        }}
      />
      <br />
      <Button
        themeColor="dark"
        onClick={() =>
          window.open(
            `mailto:${reportIssueState.emailRecipient || ''}?subject=${reportIssueState.emailSubject || ''}&body=${reportIssueState.emailBody || ''}`
          )
        }
      >
        {reportIssueState.buttonLabel}
      </Button>
    </div>
  );
};

export default ReportIssueBody;
